"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FuseFooterModule = /** @class */ (function () {
    function FuseFooterModule() {
    }
    return FuseFooterModule;
}());
exports.FuseFooterModule = FuseFooterModule;
